/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Search_DescriptionInputs */

const en_seo_search_description = /** @type {(inputs: Seo_Search_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search curated AI tools by keyword, category, tag, and filters.`)
};

const zh_seo_search_description = /** @type {(inputs: Seo_Search_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按关键词、分类、标签和筛选条件搜索精选 AI 工具。`)
};

/**
* | output |
* | --- |
* | "Search curated AI tools by keyword, category, tag, and filters." |
*
* @param {Seo_Search_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_search_description = /** @type {((inputs?: Seo_Search_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Search_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_search_description(inputs)
	return zh_seo_search_description(inputs)
});
export { seo_search_description as "seo.search.description" }